var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.$style.container,
    ( _obj = {}, _obj[_vm.$style.container_sidebar] = this.sidebar, _obj[_vm.$style.container_sheet] = this.sheet, _obj ) ],attrs:{"data-id":"page"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }